import { z } from 'zod';

import {
  cashOperationScopeTypeValues,
  type CashOperationIdentityDto,
  type CashOperationRequestIdentity,
  type CashOperationScopeType,
} from './cash-operation-identity.dto.js';

const timestampSchema = z.iso.datetime();

export const CashOperationScopeTypeSchema: z.ZodType<CashOperationScopeType> = z.enum(
  cashOperationScopeTypeValues,
);

export const CashOperationIdentityDtoSchema = z.object({
  operationId: z.uuid(),
  requestHash: z.string().trim().min(32).max(128),
  companyId: z.uuid(),
  scopeType: CashOperationScopeTypeSchema,
  scopeId: z.uuid(),
  actorUserId: z.uuid(),
  occurredAt: timestampSchema,
}) satisfies z.ZodType<CashOperationIdentityDto>;

export const CashOperationRequestIdentitySchema: z.ZodType<CashOperationRequestIdentity> = z.object(
  {
    operationId: z.uuid(),
    occurredAt: timestampSchema.optional(),
  },
);
